import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Card, Col, Form, Spinner } from "react-bootstrap";
import classes from "../RegisterNew.module.css";
import { editUserWeb } from "../../../../redux/actions/authActions";
import Select from "react-select";
import { countryListReactSelect } from "../../../../utils/utils";
import { FaCheck } from "react-icons/fa";
import { countryList } from "../../../../config/constants";
import { isMobileOnly } from "react-device-detect";

const Step = props => {
  const [userData, setUserData] = useState({});
  const [errors, setErrors] = useState({});
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    if (!!localStorage.userData) {
      setUserData(prevState => {
        return {
          ...prevState,
          ...JSON.parse(localStorage.userData),
        };
      });
    }
  }, []);

  useEffect(() => {
    setErrors({});

    if (Object.keys(props.success).length > 0) {
      if (props.success.step === 2) {
        const currentData = JSON.parse(localStorage.userData);
        localStorage.setItem(
          "userData",
          JSON.stringify({ ...currentData, ...props.success })
        );
        props.nextStep(1);
      }
    }

    if (Object.keys(props.errors).length > 0) {
      setErrors(props.errors);
      setDisableButton(false);
    }
  }, [props]);

  const handleChange = (e, target) => {
    let name;
    let value;

    if (target === "nationality") {
      name = target;
      value = e.value;
    } else if (target === "USResident") {
      name = target;
      value = e;
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    setUserData(prevState => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();

    setDisableButton(true);

    const editUser = {
      step: 2,
      subStep: 5,
      userId: props.auth.user.id,
      nationality: userData.nationality,
      USResident: userData.USResident,
    };

    props.editUserWeb(editUser);
  };

  return (
    <>
      {isMobileOnly ? (
        <>
          <h1 className={classes.h1}>Personal details</h1>
          <h2 className={classes.h2}>Nationality</h2>
        </>
      ) : (
        <h1 className={classes.h1}>Nationality</h1>
      )}

      <Card className={classes.card}>
        <Card.Body>
          <Form onSubmit={e => handleSubmit(e)}>
            <Form.Row>
              <Form.Group as={Col}>
                <Form.Label className={classes.label}>Nationality</Form.Label>
                <Select
                  name="nationality"
                  required
                  onChange={e => handleChange(e, "nationality")}
                  options={countryListReactSelect()}
                  value={{
                    label: countryList[userData.nationality] || "",
                    value: userData.nationality || "",
                  }}
                />
                <Form.Text style={{ color: "red" }}>
                  {errors.nationality}
                </Form.Text>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} className="mt-4 mb-0">
                <Form.Label className={classes.label}>
                  Are you a US citizen or US resident for tax purposes?
                </Form.Label>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group
                as={Col}
                className={classes.bigChoiceBoxCheckWrapper}
                onClick={() => handleChange("Yes", "USResident")}
              >
                <Form.Text
                  className={[
                    classes.bigChoiceBox,
                    userData.USResident && userData.USResident === "Yes"
                      ? classes.choiceBoxActive
                      : "",
                  ].join(" ")}
                >
                  <span className={classes.bigChoiceBoxCheck}>
                    <FaCheck className={classes.checkmark} />
                  </span>
                  <span className={classes.bigChoiceBoxBottom}>Yes</span>
                </Form.Text>
              </Form.Group>
              <Form.Group
                as={Col}
                className={classes.bigChoiceBoxCheckWrapper}
                onClick={() => handleChange("No", "USResident")}
              >
                <Form.Text
                  className={[
                    classes.bigChoiceBox,
                    userData.USResident && userData.USResident === "No"
                      ? classes.choiceBoxActive
                      : "",
                  ].join(" ")}
                >
                  <span className={classes.bigChoiceBoxCheck}>
                    <span className={classes.bigX}>X</span>
                  </span>
                  <span className={classes.bigChoiceBoxBottom}>No</span>
                </Form.Text>
              </Form.Group>
            </Form.Row>
            <Form.Text style={{ color: "red" }}>{errors.USResident}</Form.Text>

            <Form.Text style={{ color: "red" }}>
              {errors.server}
              {errors.userId}
            </Form.Text>

            <Button
              variant="link"
              className="simpleBackButton"
              onClick={() => props.nextStep(-1)}
            >
              BACK
            </Button>
            <Button
              type="submit"
              className="blueButton"
              disabled={disableButton}
            >
              {disableButton ? (
                <>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  NEXT
                </>
              ) : (
                "NEXT"
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

Step.propTypes = {
  auth: PropTypes.object.isRequired,
  editUserWeb: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  success: state.success,
  errors: state.errors,
});

export default connect(mapStateToProps, { editUserWeb })(Step);
